import { render } from "./LineChart.vue?vue&type=template&id=1d2478b8"
import script from "./LineChart.vue?vue&type=script&lang=js"
export * from "./LineChart.vue?vue&type=script&lang=js"

import "./LineChart.vue?vue&type=style&index=0&id=1d2478b8&lang=css"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__